import React from 'react'
import { ProgressMeter } from '@paypalcorp/pp-react'
import { trackPage } from 'ppbl/utils/fpti-helper'
import clientLogger from 'ppbl/utils/client-logger'

type Props = {
  path: string
  applicationType: string
  creditApplicationLoading: boolean
}

type ProgressMeterValues = {
  max: string
  value: string
  steps: string
  title: string
}

const withProgressMeter = function (
  progressMeterValues: ProgressMeterValues,
  Component: React.ComponentType<Props>,
) {
  return function WrappedComponent(props: Props) {
    const renderProgressBar = () => {
      trackPage({
        page: `progressBarApplicationPage${progressMeterValues?.value}`,
      })

      clientLogger.info(
        'No treatement present, application is loaded with older version of Progress Meter',
      )
      return (
        <ProgressMeter
          max={progressMeterValues.max}
          value={progressMeterValues.value}
          steps={progressMeterValues.steps}
          title={progressMeterValues.title}
          className="applicationProgressMeter"
          data-testid="progress-meter"
        />
      )
    }

    return (
      <>
        <div>{renderProgressBar()}</div>
        <Component {...props} />
      </>
    )
  }
}

export default withProgressMeter
